// A tela é da rota-pai (`app.splits.tsx`), que continua desenhada embaixo quando o detalhe
// abre no drawer (`spec/24` §1 decisão 5). Esta rota-índice existe só para `/app/splits` ser
// um destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/splits/')({ component: () => null });
